import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { MachineSafetyPluginService } from './machine-safety.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalComponent } from '../../modal/modal.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'machine-safety-edit',
  templateUrl: './machine-safety-edit.component.html',
  standalone: false
})
export class MachineSafetyEditPageComponent extends BaseModalPageComponent implements OnInit, OnDestroy {
  plugin: any;
  editForm: UntypedFormGroup;
  yesNoOptions: any[];
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public processing = false;
  private currentControlName: string;

  private sub = new Subscription();

  @ViewChild('yesNoModal', { static: true }) yesNoModal: ModalComponent;
  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('pluginDeleteConfirm', { static: true }) pluginDeleteConfirm: any;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: MachineSafetyPluginService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateMachineSafety(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.markAsTouched();
  }

  public openYesNoSelector(controlName: string) {
    this.currentControlName = controlName;
    const control = this.editForm.controls[controlName];
    this.openSelector(this.yesNoModal, this.yesNoOptions, control.value);
  }

  public selectYesNoMenu(item: any) {
    const control = this.editForm.controls[this.currentControlName];
    const selectedIndex = control.value === item.selectedIndex ? '' : item.selectedIndex;
    control.setValue(selectedIndex);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([this.inspectionsRoute, this.inspectionId, 'points', this.pointId, 'plugins', this.pluginId, 'editjson']);
  }

  gotoEditPage() {
    return this.router.navigate([this.inspectionsRoute, this.inspectionId, 'points', this.pointId, 'plugins', this.pluginId, 'edit']);
  }

  public deletePlugin() {
    this.pluginService.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  public openDeleteConfirm() {
    this.pluginDeleteConfirm.open();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);
      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);
      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();
      this.pluginId = pluginId;

      this.initData();
    });
  }

  private initData() {
    this.yesNoOptions = this.pluginService.getYesNoOptions();
    this.pluginService.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      guardsTested: new UntypedFormControl(this.plugin.config.MachineSafety.GuardsTested),
      guardsSecured: new UntypedFormControl(this.plugin.config.MachineSafety.GuardsSecured),
      customerInformedName: new UntypedFormControl(this.plugin.config.MachineSafety.CustomerInformedName),
      partsNeeded: new UntypedFormControl(this.plugin.config.MachineSafety.PartsNeeded),
      comment: new UntypedFormControl(this.plugin.config.MachineSafety.Comment)
    });
  }
}
